import { useState } from 'react';
import { IILSTableComponentProps, TableRecord } from '@common/types';

export const useFocusRow = <R extends TableRecord>(initial?: IILSTableComponentProps<R>['focusRow']) => {
  const [focusRow, setFocusRow] = useState<IILSTableComponentProps<R>['focusRow']>(initial);

  return { focusRow, setFocusRow };
};
